import {
    selectAll,
} from "d3-selection"
import {transition} from "d3-transition"
import isEqual from "lodash.isequal"
import React from "react"
import {connect} from "react-redux"
import {withRouter} from "react-router-dom"
import {colors} from "../../../utils/colors"

let debounce

class Bar extends React.Component {
    constructor() {
        super()
        this.ref = React.createRef()
    }

    componentDidMount() {
        // add a tooltip div
        const elem = document.createElement("div")
        elem.id = "tooltip-dashboard-barchart"
        document.body.appendChild(elem)

        this.init()
    }

    componentDidUpdate(prevProps) {
        const {chartData, width} = prevProps

        // handle project distribution across wards dropdown.
        if (!isEqual(chartData, this.props.chartData)) {
            this.init()
        }
        // handle window resize
        if (width !== this.props.width) {
            this.barResponsive()
        }
    }

    barTransition() {
        const { y1Key, yScale, height, chartData} = this.props
        const t = transition().duration(800)

        selectAll(".ward-chart .layer-back-bar")
            .data(chartData)
            .transition(t)
            .attr("y", d => 0)
            .attr("height", d => height)

        selectAll(".ward-chart .layer-front-bar")
            .data(chartData)
            .transition(t)
            .attr("y", d => yScale(d[y1Key]))
            .attr("height", d => height - yScale(d[y1Key]))
    }

     parseX(transformText) {
        // parsing the transform - x - value from the bottom axis ticks
         // to position the bar item correctly
        let m = transformText.match(/translate\(([0-9\.]*)/);
        let x = m[1];
        if (x) {
            return parseFloat(x);
        }
    }

    barResponsive() {
        const {chartData, height, yScale, yKey, y1Key} = this.props

        selectAll(".ward-chart .layer-back-bar")
            .data(chartData)
            .attr("x", d => this.findIndexOfBarColumn(d))
            .attr("y", d => yScale(d[yKey]))
            .attr("width", 9)
            .attr("height", d => height - yScale(d[yKey]))

        selectAll(".ward-chart .layer-front-bar")
            .data(chartData)
            .attr("x", (d) => this.findIndexOfBarColumn(d))
            .attr("y", d => yScale(d[y1Key]))
            .attr("width", 9)
            .attr("height", d => height - yScale(d[y1Key]))
    }

    findIndexOfBarColumn(d) {
        const axisNodes = [...document.querySelectorAll(".bottom-axis g")]
        const xValues = axisNodes.map(item => {
            return this.parseX(item.getAttribute("transform"))
        })
        const currentWardIndex = this.props.chartData.indexOf(this.props.chartData.filter(item => item.ward === d.ward)[0])
        return xValues[currentWardIndex] - 4.5
    }


    init() {
        const { initialBarData, height} = this.props

        selectAll(".ward-chart .layer-back-bar")
            .data(initialBarData)
            .attr("x", (d) => this.findIndexOfBarColumn(d))
            .attr("y", height)
            .attr("width", 9)

        selectAll(".ward-chart .layer-front-bar")
            .data(initialBarData)
            .attr("x", d =>  this.findIndexOfBarColumn(d))
            .attr("y", height)
            .attr("width", 9)
            .attr("height", 0)

        this.barTransition()
    }

    onMouseEnter = (e, datum) => {
        const {xKey, yKey, xScale,} = this.props


        const tooltipData = {
            left: xScale(datum[xKey]) + 8,
            bottom: (datum[yKey]),
            data: datum,
        }

        this.props.onMouseEnter(tooltipData)
    }
    onMouseLeave = e => {
        const tooltipData = {
            left: 0,
            bottom: 0,
            data: "",
        }

        this.props.onMouseEnter(tooltipData)
    }

    onClick = (e, datum) => {
        clearTimeout(debounce)
        console.log(datum)
        clearTimeout(debounce);
        this.props.history.push({
            pathname: this.props.projectType === "local-project" ? "/local-projects" : "/projects",
            search: `?ward=${datum.ward}&fiscal-year=${this.props.fiscalYear}`
        });
    }

    render() {
        const {xKey, xScale, chartData,} = this.props

        const barColor =  colors.primary.pissYellow;

        const backgroundBar = chartData.map((datum, index) => (
            <rect
                key={`back_${datum[xKey]}` + index}
                className="layer-back-bar"
                x={xScale(datum[xKey])}
                y="0"
                width={9}
                rx={4}
                ry={4}
                style={{cursor: 'pointer'}}
                fill={barColor}
                opacity="0.2"
                onMouseEnter={e => {
                    this.onMouseEnter(e, datum)
                }}
                onMouseLeave={e => {
                    this.onMouseLeave(e)
                }}
            />
        ))

        const frontBar = chartData.map((datum, index) => (
            <rect
                key={`front_${datum[xKey]}` + index}
                className="layer-front-bar"
                fill={barColor}
                x={xScale(datum[xKey])}
                y="0"
                width={9}
                rx={4}
                ry={4}
                style={{cursor: 'pointer'}}
                onMouseMove={e => {
                    this.onMouseEnter(e, datum)
                }}
                onMouseLeave={e => {
                    this.onMouseLeave(e)
                }}
               onClick={e => {
                    this.onClick(e, datum);
                }}
            />
        ))

        return (
            <g className="bar-group">
                <g className="background-bar-group">
                    {backgroundBar}
                </g>
                <g ref={this.ref} className="layer-front-bar-group">
                    {frontBar}
                </g>
            </g>
        )
    }
}

const mapStateToProps = state => ({
    fiscalYear: state.fiscalYearReducers.selectedFiscalYear,
})

export default withRouter(
    connect(
        mapStateToProps,
    )(Bar),
)



// WEBPACK FOOTER //
// ./src/components/charts/bar-chart/bar-2.js